import SecurityIcon from "@mui/icons-material/Security";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import CloudDone from "@mui/icons-material/CloudDone";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import React from "react";

export interface CategoryMapping {
  apiValue: string;
  displayLabel: string;
  icon: React.ReactElement<any>;
}

export const azureRecommendationsCategoryMap: Record<string, CategoryMapping> =
  {
    Security: {
      apiValue: "Security",
      displayLabel: "Security",
      icon: React.createElement(SecurityIcon, { fontSize: "small" }),
    },
    Cost: {
      apiValue: "Cost",
      displayLabel: "Cost",
      icon: React.createElement(LocalAtmIcon, { fontSize: "small" }),
    },
    Performance: {
      apiValue: "Performance",
      displayLabel: "Performance",
      icon: React.createElement(EqualizerIcon, { fontSize: "small" }),
    },
    HighAvailability: {
      apiValue: "HighAvailability",
      displayLabel: "Reliability",
      icon: React.createElement(CloudDone, { fontSize: "small" }),
    },
    OperationalExcellence: {
      apiValue: "OperationalExcellence",
      displayLabel: "Operational Excellence",
      icon: React.createElement(AccountTreeIcon, { fontSize: "small" }),
    },
  };

export const getCategoryDisplayLabel = (apiCategory: string): string => {
  return (
    azureRecommendationsCategoryMap[apiCategory]?.displayLabel || apiCategory
  );
};

export const getCategoryIcon = (
  apiCategory: string,
): React.ReactElement<any> | null => {
  return azureRecommendationsCategoryMap[apiCategory]?.icon || null;
};

export const getOrderedCategories = (): string[] => {
  return [
    "Security",
    "Cost",
    "Performance",
    "HighAvailability",
    "OperationalExcellence",
  ];
};
